var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkFlowEasyTraceability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7371 9.35645H24.5084V12.2976H12.7371V9.35645Z",
    fill: "url(#paint0_linear_985_5148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7371 15.2383H25.9798V18.1795H12.7371V15.2383Z",
    fill: "url(#paint1_linear_985_5148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7371 21.1206H24.5084V24.0618H12.7371V21.1206Z",
    fill: "url(#paint2_linear_985_5148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.674 22.5899C47.7945 18.5752 44.4394 15.9086 40.6941 15.3497V10.2177L31.0037 0.532715H6.85149V3.47389H0.96582V50.5327H37.7513V44.6504H40.6941V31.0767C44.4394 30.5179 47.7945 27.8512 49.674 23.8363L49.9658 23.2132L49.674 22.5899ZM31.8656 5.5536L35.6704 9.35624H31.8656V5.5536ZM34.8084 47.5915H3.90866V6.41507H6.85149V44.6504H34.8084V47.5915ZM9.79433 41.7092V3.47389H28.9228V12.2974H37.7513V15.3497C34.006 15.9086 30.651 18.5752 28.7715 22.5899L28.4797 23.2131L28.7715 23.8362C30.651 27.851 34.006 30.5177 37.7513 31.0766V41.7092H9.79433ZM39.2227 28.2467C36.247 28.2467 33.4349 26.3354 31.7505 23.2132C33.4349 20.091 36.247 18.1798 39.2227 18.1798C42.1985 18.1798 45.0106 20.091 46.695 23.2132C45.0106 26.3354 42.1985 28.2467 39.2227 28.2467Z",
    fill: "url(#paint3_linear_985_5148)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7512 21.7422H40.6941V24.6834H37.7512V21.7422Z",
    fill: "url(#paint4_linear_985_5148)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1514 33.7472L15.2491 31.846L13.1682 33.9257L17.1514 37.9066L24.0776 30.9845L21.9967 28.9048L17.1514 33.7472Z",
    fill: "url(#paint5_linear_985_5148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_5148",
    x1: 18.6227,
    y1: 9.35645,
    x2: 18.6227,
    y2: 12.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_985_5148",
    x1: 19.3584,
    y1: 15.2383,
    x2: 19.3584,
    y2: 18.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_985_5148",
    x1: 18.6227,
    y1: 21.1206,
    x2: 18.6227,
    y2: 24.0618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_985_5148",
    x1: 25.4658,
    y1: 0.532715,
    x2: 25.4658,
    y2: 50.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_985_5148",
    x1: 39.2226,
    y1: 21.7422,
    x2: 39.2226,
    y2: 24.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_985_5148",
    x1: 18.6229,
    y1: 28.9048,
    x2: 18.6229,
    y2: 37.9066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlowEasyTraceability);
export default __webpack_public_path__ + "static/media/WorkFlowEasyTraceability.55db1e64b7ba8db07527e17301a8d6f7.svg";
export { ForwardRef as ReactComponent };